<template>
  <div>
    <div v-if="loading" class="loading-bar"/>
    <div v-else class="woo-summary-wrapper">
      <div class="woo-summary-navigation">
        <v-row>
          <v-col align="right">
            <router-link :to="`/tutorial/${this.$route.params.id}`">
              <v-icon> mdi-close </v-icon>
            </router-link>
          </v-col>
        </v-row>
      </div>
      <div class="woo-summary" v-if="this.$route.query.g">
        <div class="woo-summary-content">
          <!-- <div class="woo-summary-header"></div> -->
          <div class="">
            <summary-table :passive="true" />
          </div>
        </div>
      </div>
      <v-row class="woo-summary-actions">
        <v-col align="left">
          <router-link
            :to="`/tutorial/${this.$route.params.id}?v=${prevVideoId}&s=${step.id}`"
          >
            <v-icon> mdi-arrow-left </v-icon>
          </router-link>
        </v-col>
        <v-col>
          <v-icon @click="toggleHelpDrawer()" class="help">
            mdi-help-circle-outline
          </v-icon>
        </v-col>
        <v-col align="right">
          <router-link
            :to="`/tutorial/${this.$route.params.id}?v=${nextVideoId}&s=${nextStep.id}`"
          >
            <v-icon class="next"> mdi-arrow-right </v-icon>
          </router-link>
        </v-col>
      </v-row>
      <help-drawer></help-drawer>
    </div>
  </div>
</template>

<script>
import EventHub, { Events } from '@/helpers/EventHub';
import Db from '@/helpers/Db';
import HelpDrawer from '@/components/HelpDrawer.vue';
import SummaryTable from '@/components/SummaryTable.vue';
import HelperMethods from '@/helpers/HelperMethods';
// import HelperMethods from '@/helpers/HelperMethods';

export default {
  name: 'SummaryView',
  data() {
    return {
      currentPanel: 0,
      tutorial: null,
      loading: true,
    };
  },
  computed: {
    prevVideoId() {
      return this.step.microsteps[this.step.microsteps.length - 1].id
    },
    nextVideoId() {
      return this.nextStep.microsteps[0].id
    },
    section() {
      return Db.findSectionById({
        tutorial: this.tutorial,
        sectionId: this.$route.query.g,
      })
    },
    step() {
      return this.section.steps[this.section.steps.length - 1];
    },
    nextStep() {
      return Db.findStepWithOffsetFromId({
        tutorial: this.tutorial,
        stepId: this.step.id,
        offset: 1,
      });
    },
  },
  components: { HelpDrawer, SummaryTable },
  watch: {},
  async mounted() {
    const tutorialToc = Db.getTutorialBySlug(this.$route.params.id);

    if (!tutorialToc) {
      console.log('tutorialToc not there', this.$route.params.id)
      this.$router.replace('/404');
      return;
    }

    await Db.fetchTutorial(tutorialToc.id)
      .then(tutorial => {
        this.$store.commit('setTutorial', tutorial);
        this.tutorial = tutorial;
        this.loading = false;
      })

    HelperMethods.postGoogleEvent({
      event: 'completeTutorial',
      category: 'Tutorial',
      label: 'pierre_the_penguin:shortcake:complete_kit',
    });

    if (!this.$route.query.g) {
      window.location =
        'https://docs.google.com/forms/d/e/1FAIpQLSf3gxM68e7Wf0OeRAhtDZPZvbH7DiNI0v9zna-HCWFCU6fC1Q/viewform';
    }
  },
  methods: {
    toggleHelpDrawer() {
      EventHub.$emit(Events.ShowHelp);
    },
    getStepIcon(step) {
      if (step.completed) {
        return 'mdi-check';
      } else if (step.video) {
        return 'mdi-play-outline';
      } else {
        return 'mdi-text';
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.woo {
  &-summary {
    // display: none;
    top: auto !important;
    // position: absolute !important;
    max-width: 29rem;
    margin: auto;
    border-radius: 0.75rem;
    // left: 50% !important;
    // transform: translateX(-50%);
    // height: calc(100vh - 5rem);
    width: calc(100vw - 0.5rem) !important;
    background: white;
    overflow: hidden auto;
    &-actions {
      margin: auto auto;
      top: auto !important;
      border-radius: 0.75rem;
      // left: 50% !important;
      // transform: translateX(-50%);
      color: white;
      max-width: 29rem;
      width: calc(100vw) !important;
      height: 4.5rem;
      padding: 0 0.75rem;
      bottom: 0;
      // position: absolute !important;
      button,
      .v-icon {
        color: white;
        width: 3rem;
        height: 3rem;
        font-weight: 800;
        font-size: 1.5rem;
        line-height: 2rem;
        margin: 0;
      }
    }
    &-content {
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }
    &-content::-webkit-scrollbar {
      display: none;
    }
    &-wrapper {
      background: black;
      height: 100%;
      padding: 0.25rem 0;
    }
    &-navigation {
      position: absolute;
      right: 1.775rem;
      top: 2.25rem;
      z-index: 2;
      .col {
        padding: 0;
      }
    }
    &-header {
      position: relative;
      margin-top: 1.625rem;
    }
    &-content {
      text-align: left;
      &-copy {
        margin-top: 0.5rem;
        margin-bottom: 1rem;
      }
      &-actions {
        .v-btn {
          float: right;
          margin-top: 0.5rem;
          margin-bottom: 2rem;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.overflow-y-hidden {
  .woo-tutorial-contents {
    position: absolute;
  }
}
</style>